import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import SignaturePad from "react-signature-canvas";
import { connect } from "react-redux";
// import { getTransactionDataAction } from "../../actions/TransactionActions";
import { getPublicFormTransactionDataAction } from "../../actions/TransactionActions";
// import { addDocAction, uploadDocumentAction } from "../../actions/DocActions";
import { publicAddDocAction, publicUploadDocumentAction } from "../../actions/DocActions";
import {
  logout,
  loginUserAction,
  loginUserPublicFormsAction,
  addContactByPublicFormAction,
} from "../../actions/UserActions";
import { formatPhoneNumber, toastMessage } from "../Common/Common";
import moment from "moment";
import html2pdf from "html2pdf.js";
import * as code from "../../config/Constants";
import StickyHeaderPublic from "./StickyHeaderPublic";
import InputMask from "react-input-mask";
import FooterPublic from "./FooterPublic";
var _ = require("lodash");

// var systemLoginValues = {
//   email: process.env.REACT_APP_SYSTEMLOGINVALUES_EMAIL,
//   password: process.env.REACT_APP_SYSTEMLOGINVALUES_PASSWARD,
// };

class ConsentPublic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transactionId: this.props.formData && this.props.formData.transactionId,
      studioName: "",
      clientFirstName: "",
      clientLastName: "",
      clientEmail: "",
      clientPhone: "",
      guardianName: "",
      guardianEmail: "",
      guardianPhone: "",
      hasGuardian: false,
      errors: {},
    };

    this.exportFormToPDF = this.exportFormToPDF.bind(this);
  }

  loginForPublicForm() {
    let data = { WEbEOpurMgk: "5GfFObGWzC5PNVTVbMA" };
    return this.props.loginUserPublicFormsAction(data).then((loginRes) => {});
  }

  async getTransactionData() {
    //await this.props.loginUserAction(systemLoginValues);
    // await this.loginForPublicForm();

    let transId = this.state.transactionId;
    let transaction = [];
    if (!(this.props.formData && this.props.formData.isBlankForm)) {
      await this.props
        .getPublicFormTransactionDataAction(transId)
        .then((transDataRes) => {
          transaction.push(this.props.transactionData);

          for (let i = 0; i < transaction.length; i++) {
            this.setState({
              studioName: transaction[i].dsd.property.name,
              clientFirstName: transaction[i].dsd.buyer[0].firstname,
              clientLastName: transaction[i].dsd.buyer[0].lastname
                ? transaction[i].dsd.buyer[0].lastname
                : "",
              clientEmail: transaction[i].dsd.buyer[0].email,
              clientPhone: transaction[i].dsd.buyer[0].mobileNumber,
              guardianName:
                transaction[i].dsd.closingAgents.length !== 0
                  ? transaction[i].dsd.closingAgents[0].firstname +
                    " " +
                    transaction[i].dsd.closingAgents[0].lastname
                  : "",
              guardianEmail:
                transaction[i].dsd.closingAgents.length !== 0
                  ? transaction[i].dsd.closingAgents[0].email
                  : "",
              guardianPhone:
                transaction[i].dsd.closingAgents.length !== 0
                  ? transaction[i].dsd.closingAgents[0].mobileNumber
                  : "",
              hasGuardian:
                transaction[i].dsd.closingAgents.length !== 0 ? true : false,
            });
          }
        });
    }

    this.props.logout();
  }

  componentDidMount() {
    this.getTransactionData();
  }

  async exportFormToPDF() {
    //await this.props.loginUserAction(systemLoginValues);
    // await this.loginForPublicForm();

    let form = document.getElementById("formToExport");

    let transId = this.state.transactionId;

    //Setup the filename
    const dt = new Date();
    let filestamp =
      "_" +
      dt.getFullYear().toString() +
      (dt.getMonth() + 1).toString() +
      dt.getDate().toString() +
      dt.getHours().toString() +
      dt.getMinutes().toString() +
      dt.getSeconds().toString();
    let clientFullName =
      this.state.clientFirstName.trim() +
      (this.state.clientLastName ? " " + this.state.clientLastName.trim() : "");
    let fileName =
      "checkin" +
      (clientFullName ? "_" + clientFullName : "") +
      filestamp +
      ".pdf";
    let fn = fileName.split(" ").join("_");

    //Set the pdf Export Options
    let opt = {
      margin: 1.5,
      filename: fn,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2.5, width: 1200 },
      jsPDF: { unit: "in", format: "a1", orientation: "p" },
    };

    //Begin the fileupload setup
    var documents = [];
    var docDetail = {};

    //Exports the file to a blob
    const blob = await html2pdf()
      .set(opt)
      .from(form)
      .toPdf()
      .output("blob", fn);

    //Set the file details for the insert into the ducuments colection
    docDetail = {
      fileName: fn,
      size: (blob.size / (1024 * 1024)).toFixed(2),
    };
    documents.push(docDetail);

    var dataToPost = {
      transactionId: transId,
      location: "Transaction Docs",
      document: documents,
    };

    //Setup the formdata for the fileupload to s3
    var formData = new FormData();
    formData.append("file", blob, fn);

    if (this.state.clientEmail || this.state.clientPhone) {
      let data = {
        firstname: this.state.clientFirstName,
        lastname: this.state.clientLastName,
        email: this.state.clientEmail,
        mobileNumber: this.state.clientPhone.replace(/-/g, ""),
        usertype: "Client",
        transactionId: transId,
        knowAboutUs: this.props.formData && this.props.formData.knowAboutUs,
      };
      this.props.addContactByPublicFormAction(data).then((res) => {});
    }

    //addDocAction writes the mongodb record about the file and returns the unique file name that will be stored in 33
    this.props.publicAddDocAction(dataToPost).then((res) => {
      if (res.status === code.OK) {
        var fileUploadName = "";
        res.data.map((item) => {
          if (fileUploadName.length > 0) {
            fileUploadName +=
              "@@@" + item.document + "###" + item.uploadedFileName;
          } else {
            fileUploadName = item.document + "###" + item.uploadedFileName;
          }
          //uploadDocumentAction actually sends the file to S3
          this.props
            .publicUploadDocumentAction(
              formData,
              transId,
              undefined,
              fileUploadName
            )
            .then((isValidDoc) => {
              // console.log("VALID");
              //Export the file for download
              html2pdf()
                .set(opt)
                .from(form)
                .save();
              this.props.logout();
              this.props.history.push("/formreceived");
            });
        });
      } else {
        //console.log("BAD addDocAction Status: " + res.status);
        toastMessage(code.ERROR, res.data);
      }
    });
  }

  errorHandler(errors) {
    this.setState({
      errors: errors,
    });
  }

  render() {
    // console.log("systemLoginValues-98", systemLoginValues);
    return (
      <div className="admin-steps admin-content-area">
        <StickyHeaderPublic
          form={this.props.formData && this.props.formData.form}
          exportFormToPDF={this.exportFormToPDF.bind(this)}
          errorHandler={this.errorHandler.bind(this)}
          transaction={this.state}
        />
        <div className="container-custom">
          <Form className="form-sm form-admin" id="formToExport">
            <Row>
              <Col xs={12}>
                <h3 className="title-medium font-600 mt-5 mb-3 pt-3">
                  Register for Tattoo City Convention communications, updates,
                  and future events
                </h3>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>
                    Client First Name<span className="text-danger"> *</span>:
                  </Form.Label>
                  <Form.Control
                    value={
                      this.state.clientFirstName
                        ? this.state.clientFirstName
                        : ""
                    }
                    onChange={(e) =>
                      this.setState({ clientFirstName: e.target.value })
                    }
                    isInvalid={!!this.state.errors.clientFirstName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientFirstName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Client Last Name:</Form.Label>
                  <Form.Control
                    value={
                      this.state.clientLastName ? this.state.clientLastName : ""
                    }
                    onChange={(e) =>
                      this.setState({ clientLastName: e.target.value })
                    }
                    isInvalid={!!this.state.errors.clientLastName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientLastName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Client Email:</Form.Label>
                  <Form.Control
                    type="email"
                    value={this.state.clientEmail ? this.state.clientEmail : ""}
                    onChange={(e) =>
                      this.setState({ clientEmail: e.target.value })
                    }
                    isInvalid={!!this.state.errors.clientEmail}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientEmail}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Client Mobile Number:</Form.Label>

                  <InputMask
                    mask="999-999-9999"
                    maskChar=""
                    formControlProps={{
                      fullWidth: true,
                    }}
                    onChange={(e) =>
                      this.setState({ clientPhone: e.target.value })
                    }
                    value={
                      this.state.clientPhone
                        ? formatPhoneNumber(this.state.clientPhone)
                        : ""
                    }
                    name="clientPhone"
                  >
                    {(inputProps) => <Form.Control {...inputProps} />}
                  </InputMask>
                  {this.state.errors.clientPhone && (
                    <div
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {this.state.errors.clientPhone}
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </div>
        <FooterPublic
          form={this.props.formData && this.props.formData.form}
          exportFormToPDF={this.exportFormToPDF.bind(this)}
          errorHandler={this.errorHandler.bind(this)}
          transaction={this.state}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transactionData: state.reducer.transactionData,
  };
};

export default connect(mapStateToProps, {
  getPublicFormTransactionDataAction,
  publicAddDocAction,
  publicUploadDocumentAction,
  loginUserAction,
  logout,
  loginUserPublicFormsAction,
  addContactByPublicFormAction,
})(ConsentPublic);
